import CertifiedPayrollWebp from '../assets/images/CertifiedPayroll.webp';
import CertifiedPayrollPng from '../assets/images/CertifiedPayroll.png';

import QuickBooks1Webp from '../assets/images/QuickBooks1.webp';
import QuickBooks1Png from '../assets/images/QuickBooks1.png';

import QuickBooks2Webp from '../assets/images/QuickBooks2.webp';
import QuickBooks2Png from '../assets/images/QuickBooks2.png';

import TrainedBookkeeperWebp from '../assets/images/TrainedBookkeeper.webp';
import TrainedBookkeeperPng from '../assets/images/TrainedBookkeeper.png';


export type SourceData = {
    srcSet: string,
    type: string
}

export type CredentialData = {
    alt: string,
    source: SourceData[],
    fallbackSrc: string
}

export const credentialData: CredentialData[] =[
    {
        alt: "Graphic of Intuit's QuickBooks Payroll certificate",
        source: [
            { srcSet: CertifiedPayrollWebp, type: "image/webp"}
        ],
        fallbackSrc: CertifiedPayrollPng,
    },
    {
        alt: "Graphic of Intuit's QuickBooks Level 1",
        source: [
            { srcSet: QuickBooks1Webp, type: "image/webp"}
        ],
        fallbackSrc: QuickBooks1Png,
    },
    {
        alt: "Graphic of Intuit's QuickBooks Level 2",
        source: [
            { srcSet: QuickBooks2Webp, type: "image/webp"}
        ],
        fallbackSrc: QuickBooks2Png,
    },
    {
        alt: "Graphic of Intuit's Trained Bookkeeper certificate",
        source: [
            { srcSet: TrainedBookkeeperWebp, type: "image/webp"}
        ],
        fallbackSrc: TrainedBookkeeperPng,
    },
]